import { useQuery } from '@tanstack/react-query';
import { useActiveOrg } from '../providers/useActiveOrg';
import { useTypedOpenApi } from '../providers/useTypedOpenApi';
import { fetchOrganizationMembers } from './organizationMembers';

export const organizationMembersKey = (clerkOrgId: string | null) => ['organization-members', clerkOrgId] as const;

/**
 * The active organization's members, for every member. Keyed by the Clerk org id, so a switch never
 * offers the last organization's people.
 *
 * Online only: there is no members table on the device. Offline the pickers fall back to what they
 * already hold (the user, and whoever the record names), which the API accepts anyway.
 */
export const useOrganizationMembersQuery = () => {
  const { apiClient } = useTypedOpenApi();
  const { clerkOrgId } = useActiveOrg();

  return useQuery({
    queryKey: organizationMembersKey(clerkOrgId),
    queryFn: () => fetchOrganizationMembers(apiClient),
    enabled: clerkOrgId !== null,
    staleTime: 60 * 1000,
  });
};
